import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavCountdown from 'components/NavCountdown';
import v from 'vudu';
import { styles as s, breakpoints, colors } from 'stylesheet';
import FrameSolidLockup from 'components/svgs/FrameSolidLockup';
import { Link } from 'react-router-dom';
import EmailForm from 'components/EmailForm';
import get from 'utils/get';

import { TimelineLite } from 'gsap';
import EasePack from 'gsap/EasePack';

const localClasses = v({
  stickyNav: {
    '@composes': [s.fixed, s.t0, s.z2],
    height: '70px',
    width: '100%',
    display: 'flex'
  },
  stickyNavBackground: {
    '@composes': [s.absolute],
    width: '100%',
    height: '100%',
    backgroundColor: 'red',
    backgroundImage: `linear-gradient(226deg, #5D1F5A 0%, #231E4A 100%)`,
    boxShadow: `0 20px 24px 0 rgba(0,0,0,0.30)`
  },
  stickyNavInner: {
    '@composes': [s.flex, s.relative, s.z1, s.t0],
    width: '100%',
    paddingLeft: '20px',
    paddingRight: '20px',
    maxWidth: '1040px',
    margin: 'auto'
  },
  navHalf: {
    'aside': { display: 'none' },
    'section': {
      '@composes': [s.pl2],
      textAlign: 'left'
    }
  },
  emailInput: {
    textAlign: 'left',
    flexGrow: 1,
    flexBasis: 0,
    'img': {
      width: '100%',
      maxWidth: '140px'
    },
    'form': {
      margin: 'auto',
      paddingLeft: 0,
    },
    [breakpoints.md]: {
      margin: 'inherit',
      paddingTop: 0,
    },
    [breakpoints.lg]: {
      margin: 'auto',
      width: '35%',
      textAlign: 'center',
      paddingLeft: 0,
    },
  },
  navCountdownWrapper: {
    display: 'none',
    flexGrow: 1,
    flexBasis: 0,
    [breakpoints.md]: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'flex-end',
    }
  },
  logoWrapper: {
    '@composes': [s.pl2],
    flexGrow: 1,
    flexBasis: 0,
    display: 'none',
    [breakpoints.lg]: {
      display: 'flex',
      alignItems: 'center'
    }
  }
});

class StickyNav extends Component {
  componentDidMount() {
    this.timeline = new TimelineLite({ paused: true });

    this.timeline
      .fromTo(this.backing, 0.45, { width: '0%' }, { width: '100%', ease: EasePack.Expo.easeIn }, 's')
      .staggerFromTo(
        [this.logo, this.email, this.counter],
        0.45,
        { opacity: 0, y: -50 },
        { opacity: 1, y: 0, ease: EasePack.Expo.easeInOut },
        0.15,
        's+=0.15'
      )
  }

  componentWillReceiveProps(nextProps) {
    if (get(this, 'props.isVisible') !== get(nextProps, 'isVisible')) this.animateNav(get(nextProps, 'isVisible'));
  }

  animateNav(shouldShow) {
    this.timeline.stop();
    if (shouldShow) this.timeline.play()
    else this.timeline.reverse()
  }

  render () {
    let variant = 'white', split = 'full';
    let navClasses = localClasses.stickyNav;
    if (split === 'half') navClasses += ` ${localClasses.navHalf}`;
    return (
      <header className={navClasses} style={ this.props.isVisible ? { pointerEvents: 'auto'} : { pointerEvents: 'none' } }>
        <div className={localClasses.stickyNavBackground} ref={r => this.backing = r}></div>
        <div className={localClasses.stickyNavInner}>
          <aside className={localClasses.logoWrapper} ref={r => this.logo = r}>
            <Link to="/" style={{ display: 'flex' }}>
              <FrameSolidLockup fill={colors[variant]} />
            </Link>
          </aside>
          <section className={localClasses.emailInput} ref={r => this.email = r}>
            <EmailForm isFixed position={'header'} />
          </section>
          <div className={localClasses.navCountdownWrapper} ref={r => this.counter = r}>
            <NavCountdown color={variant} />
          </div>
        </div>
      </header>
    );
  }
}

function mapStateToProps(state) {
  return {
    isVisible: get(state, 'viewState.stickyNav.isVisible', false)
  };
}


export default connect(mapStateToProps)(StickyNav);



// WEBPACK FOOTER //
// ./src/components/StickyNav.js